export var RequiredTimeUnit;(function(RequiredTimeUnit){RequiredTimeUnit["YES"]="!";RequiredTimeUnit["NO"]="?"})(RequiredTimeUnit||(RequiredTimeUnit={}));
//# sourceMappingURL=enums.js.map